import { getPorpoiseSubdomain } from '../../components/api';
import {
  Campaign, CheckoutRequest, CheckoutResponse, ClaimStatus,
} from './types';

// webshop-api is the 'shop' Porpoise subdomain — resolved the canonical cross-service way (per-namespace / live host).
const EXTERNAL_SALES_API_BASE = getPorpoiseSubdomain('shop');

export class ExternalSalesApiError extends Error {
  constructor(public readonly status: number) {
    super(`External sales API error: ${status}`);
    this.name = 'ExternalSalesApiError';
  }
}

export async function fetchCampaign(campaignCode: string): Promise<Campaign> {
  const response = await fetch(
    `${EXTERNAL_SALES_API_BASE}/neon/guest/campaign/${encodeURIComponent(campaignCode)}`,
  );
  if (!response.ok) {
    throw new ExternalSalesApiError(response.status);
  }
  return response.json();
}

// 202 = checkout in-flight, redirect URL not yet minted — a success variant,
// distinct from the 200 redirect; non-2xx (409/422/5xx) surfaces as ExternalSalesApiError.
export type CheckoutSuccess =
  | { status: 'redirect'; redirectUrl: string }
  | { status: 'pending' };

export async function submitCheckout(request: CheckoutRequest): Promise<CheckoutSuccess> {
  const response = await fetch(`${EXTERNAL_SALES_API_BASE}/neon/guest/checkout`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  });
  if (response.status === 202) {
    return { status: 'pending' };
  }
  if (!response.ok) {
    throw new ExternalSalesApiError(response.status);
  }
  const { redirectUrl }: CheckoutResponse = await response.json();
  return { status: 'redirect', redirectUrl };
}

export async function fetchClaimStatus(token: string): Promise<ClaimStatus> {
  const params = new URLSearchParams({ token });
  const response = await fetch(`${EXTERNAL_SALES_API_BASE}/neon/guest/claim-status?${params.toString()}`);
  if (!response.ok) {
    throw new ExternalSalesApiError(response.status);
  }
  return response.json();
}
